import { Form } from 'antd';
import React from 'react';

import Input from '@/atoms/input';
import { FilterComponentInput } from '@core/offices/types';

const component = (props: FilterComponentInput) => {
  return (
    <Form.Item label={props.filter.label} initialValue={props.value}>
      <Input
        value={props.value}
        type={props.filter.componentType}
        {...props}
        onChange={(e) => props.handleChange(e.target.value)}
      />
    </Form.Item>
  );
};
export default component;
